import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Gasequipment from '../entities/gasequipment'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface GasequipmentState extends ListState<Gasequipment>{
    editGasequipment:Gasequipment,
    analyseGasequipment: Gasequipment
}
class UserMutations extends ListMutations<Gasequipment>{

}
class GasequipmentModule extends ListModule<GasequipmentState,any,Gasequipment>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        analyseGasequipment: new Array<Gasequipment>(),
        list: new Array<Gasequipment>(),
        loading:false,
        editGasequipment:new Gasequipment()
    }
    actions={
        async getPage(context:ActionContext<GasequipmentState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/GasEquipment/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Gasequipment>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getDataforExcel(context:ActionContext<GasequipmentState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/GasEquipment/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Gasequipment>;
            return page.items;
        },
        async getCountHome(context:ActionContext<GasequipmentState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/GasEquipment/GetCountHome');
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Gasequipment>;
            return page;
        },
        async getCountHomeEchart(context:ActionContext<GasequipmentState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/GasEquipment/GetCountHomeEchart');
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Gasequipment>;
            return page;
        },
        async GetRealPaged(context:ActionContext<GasequipmentState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/GasEquipment/GetRealPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Gasequipment>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            return page.items;
        },
        async GetGlobalPaged(context:ActionContext<GasequipmentState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/GasEquipment/GetGlobalPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Gasequipment>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getAll(context:ActionContext<GasequipmentState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/GasEquipment/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Gasequipment>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getEquList(context:ActionContext<GasequipmentState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/GasEquipment/GetEquList',{params:payload.data});
            return reponse.data.result;
        },
        async create(context:ActionContext<GasequipmentState,any>,payload:any){
            await Ajax.post('/api/services/app/GasEquipment/Create',payload.data);
        },
        async uploadimg(context:ActionContext<GasequipmentState,any>,payload:any){
            //console.log(payload.data.UploadData);
            await Ajax.post('/api/services/app/UploadFile/UploadFile',{params:payload.data.UploadData});
        },
        async update(context:ActionContext<GasequipmentState,any>,payload:any){
            await Ajax.put('/api/services/app/GasEquipment/Update',payload.data);
        },
        async delete(context:ActionContext<GasequipmentState,any>,payload:any){
            await Ajax.delete('/api/services/app/GasEquipment/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<GasequipmentState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/GasEquipment/GetById?Id='+payload.id);
            return reponse.data.result as Gasequipment;
        },
        ///获取设备数量
        async getCount(context:ActionContext<GasequipmentState,any>,payload:any){
            //console.log(payload);
            let reponse=await Ajax.get('/api/services/app/GasEquipment/GetCount?status='+payload.data.status);
            return reponse.data.result.count;
        },
        //通过mac获取设备
        async getPageBymac(context:ActionContext<GasequipmentState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/GasEquipment/GetPaged',{params:payload.data});
            return reponse.data.result.items as Gasequipment;
        }
    };
    mutations={
        setCurrentPage(state:GasequipmentState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:GasequipmentState,pagesize:number){
            state.pageSize=pagesize;
        },
        analyse(state: GasequipmentState, gasequipment: Gasequipment) {
            state.analyseGasequipment = gasequipment;
        },
        edit(state:GasequipmentState,gasequipment:Gasequipment){
            
            state.editGasequipment=gasequipment;
            //console.log(state.editFloor);
        }
    }
}
const gasequipmentModule=new GasequipmentModule();
export default gasequipmentModule;